export default __webpack_public_path__ + "static/media/tractor_online.64af2f30.svg";